import { createSlice } from "@reduxjs/toolkit";

export const ProjectMembersSlice = createSlice({
    name : 'project_members',
    initialState : {
        value : []
    },
    reducers : {
        updateProjectMembersCollection: (state, action) => {
            state.value = action.payload;
        }
    }
});

export const { updateProjectMembersCollection } = ProjectMembersSlice.actions

export default ProjectMembersSlice.reducer